import {parseUri} from 'BenchlingUtil';
import {makeCompatibleApiId} from 'folder-items/FileUtil';
import EditorRoutes from 'foundation/EditorRoutes';
import {HOMEPAGE_PATH} from 'nav/sidepanel/homepage/HomepageConstants';
import noOpRoute from 'routing/noOpRoute';
import {RouteBundle} from 'routing/RouteConstants';

export const NavRoutes: RouteBundle = {
  domain: 'nav',
  routes: [
    {urlPattern: 'privacy', handler: noOpRoute, legacy: true},
    {urlPattern: 'terms', handler: noOpRoute, legacy: true},
    {urlPattern: 'about', handler: noOpRoute, legacy: true},
    {urlPattern: 'crispr', handler: noOpRoute, legacy: true},
    {urlPattern: 'editor', handler: EditorRoutes.editor.bind(EditorRoutes), legacy: true},
    {urlPattern: 'projects/', handler: EditorRoutes.projects.bind(EditorRoutes), legacy: true},
    {urlPattern: 'storage', handler: EditorRoutes.storage.bind(EditorRoutes), legacy: true},
    {
      urlPattern: ':currentUserUrl/f/:folderIdentifier/:itemUrlIdentifier/edit',
      handler: folderItemEditor,
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/f_/:folderIdentifier/',
      handler: EditorRoutes.elnFolder.bind(EditorRoutes),
      legacy: true,
    },
    {urlPattern: HOMEPAGE_PATH.slice(1), handler: EditorRoutes.homepage.bind(EditorRoutes)},
  ],
};

/*
 * This route supports two formats for folder item URLs:
 * - Legacy:  /f/XyZ123-my-folder/etr-AbC42-my-entry_1/edit
 * - Current: /f/lib_XyZ123-my-folder/etr_AbC42-my-entry_1/edit
 *
 * While the backend already redirects the legacy-style URL to the current-style URL,
 * there are cases where the front-end may trigger single-page-app routing to a
 * legacy URL (e.g. when such a URL is stored within notebook contents). These URLs
 * may be stored indefinitely and so this route needs to be maintained indefinitely.
 */
function folderItemEditor(_userId: string, _folderId: string, fileUrlId: string): void {
  const {queryKey} = parseUri(window.location.href);
  EditorRoutes.folderItemEditor(makeCompatibleApiId(fileUrlId), queryKey);
}
